import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const quizTextInputViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map